var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"block text-xs font-bold text-cal-525252 p-0",attrs:{"for":_vm.isFor}},[_vm._t("default"),_vm._v(":")],2)}
var staticRenderFns = []

export { render, staticRenderFns }